/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';

import { Logger }                from '@/util/logger';
import { IProjectRow }           from "@/screens/administration/i.project.row";
import { first }                 from "rxjs/operators";
import { ProjectService }        from "@/services/project.service";
import { IOrganizationRow }      from "@/screens/administration/i.organization.row";
import { Inplace }               from "primeng/inplace";
import { OrganizationService }   from "@/services/organization.service";
import { UserService }           from "@/services/user.service";
import { AuthenticationService } from "@/services/authentication.service";

@Component({
  standalone: false,
  templateUrl: 'my.organizations.component.html'
})

/**
 *
 * @class MyOrganizationsComponent
 *
 * @brief let the user view their own organizations
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class MyOrganizationsComponent implements OnInit {

  /** the organizations where they are an administrator */
  public organizations: IProjectRow[]  = [];

  /** the organizations key to use for creation */
  public orgCreateKey: string    = '';

  /** the organizations name to use for creation */
  public orgCreateName: string   = '';

  /** is the current key/organizations name valid for creating an organization? */
  public orgInputValid: boolean  = false;

  /** standard constructor */
  constructor(
    private prjservice: ProjectService,
    private orgservice: OrganizationService,
    private users:      UserService,
    private auth:       AuthenticationService,
    private cdRef:      ChangeDetectorRef
  ) {

  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[MyOrganizationsComponent] init...');

    let mpo: MyOrganizationsComponent = this;

    mpo.refresh();
  }

  /** check if the viewer is a system admin */
  isSystemAdmin(): boolean {

    let mpo: MyOrganizationsComponent = this;

    return mpo.auth.isAdmin();
  }

  /** render the page */
  refresh() {

    let mpo: MyOrganizationsComponent = this;

    Logger.debug(`[MyOrganizationsComponent] looking for organizations...`);

    mpo.orgservice.myOrganizations()
      .pipe(first())
      .subscribe({

        next: (data: any) => {

          mpo.organizations = [];

          if (data.result) {

            data = data.result;
          }

          data.organizations.forEach((item) => {

            mpo.organizations.push(item);

          });

          mpo.organizations.sort((a: IOrganizationRow, b: IOrganizationRow) => {

            return a.name.localeCompare(b.name);
          });

          Logger.debug(`[MyOrganizationsComponent] organizations: `, mpo.organizations);

          mpo.cdRef.detectChanges();
        },

        error: (error: any): void => {

          Logger.error(`[MyOrganizationsComponent] could not fetch organizations: `, error);

        }

      });
  }

  /** check the "key" input for creating a organization */
  checkKey(event = null) {

    let mpo: MyOrganizationsComponent = this;

    let name: string = $(`#createorganizationlight`).val().toString().trim();
    let key: string = $(`#createorganizationkeylight`).val().toString();

    /* clear the current error */

    mpo.orgInputValid = true;
    $(`.orgcreateerror`).html('');

    /* any validation issues? */

    if (!/^[a-zA-Z][_a-zA-Z0-9]+$/.test(key)) {

      $(`.orgcreateerror`).html('Organization key must be of pattern [a-zA-Z][_a-zA-Z0-9]+');

      mpo.orgInputValid = false;

      return false;
    }

    if (!name) {

      $(`.orgcreateerror`).html('Organization name can not be empty.');

      mpo.orgInputValid = false;

      return false;
    }

    if (event != null) {

      /* if it's a key up change, only trigger on RETURN */

      if (event.key == 'Enter') {

        mpo.createOrganization(true);
      }

    }

    /* clear to proceed! */

    return true;
  }

  clearPicker() {

    let mpo: MyOrganizationsComponent = this;

    $(`#createorganizationlight`).val('');
    $(`#createorganizationkeylight`).val('');

    mpo.orgInputValid = false;
  }

  createOrganization(noCheck: boolean  = false) {

    let mpo: MyOrganizationsComponent = this;
    let name: string              = $(`#createorganizationlight`).val().toString();
    let key: string               = $(`#createorganizationkeylight`).val().toString();

    if (!noCheck) {

      /* we haven't checked the values yet */

      if (!mpo.checkKey()) {

        /* validation errors */

        return;
      }
    }

    mpo.clearPicker();

    Logger.debug(`[MyOrganizationsComponent] creating new organization: '${name}', '${key}'...`);

    mpo.orgservice.create({name, key})
      .pipe(first())
      .subscribe({

        next: (data: any) => {

          Logger.debug(`[MyOrganizationsComponent] organization created, refreshing...`);

          mpo.refresh();

        },

        error: (error: any): void => {

          Logger.error(`[MyOrganizationsComponent] could not create organization: `, error);
        }

      });

  }

  /** set a new name for the given organization */
  saveOrgName(id: number, name: string) {

    let mpo: MyOrganizationsComponent = this;

    let org: IOrganizationRow = mpo.organizations.find(x => x.id == id);

    if (!org) {

      return ;
    }

    /* update locally */

    org.name = name;

    /* update the database... */

    mpo.orgservice.update(id, {name})
      .pipe(first())
      .subscribe({

        next: (data: any) => {

          /* refresh the list ... */

          mpo.refresh();

        },

        error: (error: any): void => {

          Logger.error(`[MyOrganizationsComponent] could not save new organization name: `, error);

        }

      });

  }

  orgEditKey(event, id: number, component: Inplace) {

    let mpo: MyOrganizationsComponent = this;
    let value: string = $(`.orgclass-${id} input`).val().toString();

    if (event.key != 'Enter') {

      return ;
    }

    Logger.debug(`[MyOrganizationsComponent] org editor RETURN (${id}) => '${value}': `, event);

    mpo.saveOrgName(id, value);

  }

  orgEditDeactivate(id: number, component: Inplace) {

    let mpo: MyOrganizationsComponent = this;
    let value: string = $(`.orgclass-${id} input`).val().toString();

    Logger.debug(`[MyOrganizationsComponent] deactivating org editor (${id}) => '${value}': `, component);

    mpo.saveOrgName(id, value);

  }

  orgEditActivate(id: number, component: Inplace) {

    let mpo: MyOrganizationsComponent = this;

    Logger.debug(`[MyOrganizationsComponent] activating org editor (${id}): `, component);


  }

}

